import React, { FC } from 'react'
import { Tabs as AntTabs } from 'antd'
import {
  TabsProps as AntTabsProps,
  TabPaneProps as AntTabsPaneProps
} from 'antd/lib/tabs'

export type TabProps = AntTabsProps
export type TabsPaneProps = AntTabsPaneProps

export const Tabs: FC<TabProps> = ({
  children,
  tabBarExtraContent,
  activeKey,
  defaultActiveKey,
  className,
  onTabClick
}) => {
  return (
    <AntTabs
      tabBarExtraContent={tabBarExtraContent}
      activeKey={activeKey}
      defaultActiveKey={defaultActiveKey}
      className={className}
      onTabClick={onTabClick}
    >
      {children}
    </AntTabs>
  )
}

export const TabPane: React.FC<TabsPaneProps> = ({
  children,
  className,
  tabKey,
  tab,
  active
}) => (
  <AntTabs.TabPane
    className={className}
    tabKey={tabKey}
    tab={tab}
    key={tabKey}
    active={active}
  >
    {children}
  </AntTabs.TabPane>
)
